module.exports = __webpack_public_path__ + "static/media/RahatAliDar4.b9a3e891.jpg";